import React from 'react'

import LabelTitleText from 'components/shared/LabelTitleText'
import Image from 'components/shared/Image'
import TriangleImage from 'components/shared/TriangleImage'
import Layout from 'components/shared/Layout'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const WhiteHero = ({
  topRightImage,
  logoImage,
  intro,
  children,
}) => {
  const withoutTopImage = !topRightImage
  
return (
  <Layout type="maxWidth" className={cx(css.WhiteHero, { withoutTopImage })}>
    {topRightImage && (
    <div className={css.topRightDecoration}>
      {topRightImage && (
      <TriangleImage
        className={css.topRightDecorationImage}
        {...topRightImage}
      />
          )}
          <Image
            className={css.topRightDecorationIcon}
            media={{ width: 229, height: 136 }}
            src="/assets/white-hero/top-right.svg"
            alt="dots"
            priority
          />
        </div>
      )}
    <Layout type="wrapper">
      <Layout type="smallInnerWrapper">
        {intro && (
        <LabelTitleText
          {...intro}
          titleProps={{ tag: 'h1' }}
          textProps={{ tag: 'h2' }}
          className={css.contentWrapper}
          beforeChildren={() =>
                logoImage && (
                  <Image
                    className={css.logoWrapper}
                    forcedRatio={1}
                    fit="contain"
                    position="top"
                    {...logoImage}
                  />
                )}
        />
          )}
        {children}
      </Layout>
    </Layout>
    <Image
      className={css.bottomLeftDecoration}
      src="/assets/white-hero/bottom-left.svg"
      media={{ width: 135, height: 41 }}
      alt="dots"
    />
  </Layout>
  )
}

WhiteHero.defaultProps = {}

export default WhiteHero
